// FAQ : le titre reste collé à gauche pendant qu'on lit les réponses à droite,
// avec la sortie WhatsApp pour la question qui n'y est pas.
import { useT } from '../../lib/i18n'
import { whatsappLink } from '../../lib/support'

export default function Faq () {
  const f = useT().faq
  const wa = whatsappLink()
  return (
    <section className="lp-sec" id="faq">
      <div className="lp-wrap lp-faqw">
        <div className="lp-faqw__head lp-rv">
          <span className="lp-kicker">{f.kicker}</span>
          <h2 className="lp-h2">{f.title}</h2>
          {wa && (
            <p className="lp-faqw__help">
              {f.help} <a href={wa} target="_blank" rel="noopener noreferrer" className="lp-link">{f.helpLink} →</a>
            </p>
          )}
        </div>

        <div className="lp-faq lp-rv">
          {f.items.map(({ q, a }, i) => (
            <details key={q} open={i === 0}>
              <summary>{q}<span className="lp-faq__ic" aria-hidden="true" /></summary>
              <p className="lp-faq__a">{a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  )
}
